import { TextField } from '@mui/material'
import React from 'react'

import { SERVICE_ACCOUNT_ID_FIELD_PROPS } from 'components/common/mapped-entities/gcp/authentication/gcp-auth-form-utils'
import { GCP_INTEGRATION_SETUP_MESSAGES } from 'components/common/mapped-entities/gcp/authentication/gcp-integration-utils'
import { GcpAuthenticationSection } from 'components/common/mapped-entities/gcp/authentication/GcpAuthenticationSection'
import { ViewOnlyAlert } from 'components/common/mapped-entities/ViewOnlyAlert'
import PageSection from 'components/common/PageSection'
import { useGetGcpIntegrationSetup } from 'queries/gcp/use-get-gcp-integration-setup'
import { type TeamExternalIntegration } from 'types/api/status-checks/status-check'
import { messageFromResponseError } from 'utils/strings'

export function GcpAuthenticationSectionReadOnly({
  selectedIntegration
}: {
  selectedIntegration: TeamExternalIntegration
}) {
  const {
    data: gcpIntegrationSetupData,
    error: errorGcpMetadataAuth,
    isError: isErrorGcpMetadataAuth,
    isLoading: isLoadingGcpMetadataAuth
  } = useGetGcpIntegrationSetup()

  return (
    <PageSection
      errorMessage={messageFromResponseError(
        errorGcpMetadataAuth,
        GCP_INTEGRATION_SETUP_MESSAGES.errorFallback
      )}
      hasError={isErrorGcpMetadataAuth}
      isLoading={isLoadingGcpMetadataAuth}
      isLoadingOverlayFullScreen={false}
    >
      {() => {
        if (!gcpIntegrationSetupData) {
          throw new Error(GCP_INTEGRATION_SETUP_MESSAGES.unexpectedResponse)
        }

        return (
          <>
            <ViewOnlyAlert />
            <GcpAuthenticationSection {...gcpIntegrationSetupData}>
              <TextField
                {...SERVICE_ACCOUNT_ID_FIELD_PROPS}
                disabled
                value={
                  selectedIntegration.integrationSpecificValues
                    ?.serviceAccount ?? ''
                }
              />
            </GcpAuthenticationSection>
          </>
        )
      }}
    </PageSection>
  )
}
